
import { Component, Vue } from "vue-property-decorator";
import {OrganizationUnitDto} from "@/api/appService";

@Component({
  name: "Dashboard"
})
export default class extends Vue {
  get ou() :OrganizationUnitDto{
    return this.$store.getters['user/ou']
  }

  created() {
    console.log("beforeCreate");
    const ou = this.ou;
    if (ou) {
      switch (ou.level) {
        case "总部":
          this.$router.push({ name: "dashboard-headquarters" });
          break;
        case "大区":
          this.$router.push({ name: "dashboard-region" });
          break;
        case "片区":
          this.$router.push({ name: "dashboard-district" });
          break;
        case "门店":
          this.$router.push({ name: "dashboard-store" });
          break;
        default:
          break;
      }
    }
  }

  get name() {
    return this.$store.getters['user/name'];
  }

  get roles() {
    return this.$store.getters['user/roles'];
  }

  // created() {
  //   // this.$router.push({name:'dashboard-store'})
  //   // this.$router.push({name:'dashboard-headquarters'})
  //   // this.$router.push({name:'dashboard-region'})
  //   // this.$router.push({name:'dashboard-district'})
  // }
}
